<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Promotions
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-index' })">
            <i class="fa fa-gift"></i> Promotions
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-bin-index' })">
            <i class="fa fa-bank"></i> BIN
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3>Filter Promo Bin</h3>
          <div class="box-tools pull-right">
            <button type="button"
              class="btn btn-box-tool"
              data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: hidden;">
          <div class="form-group">
            <label for="promo_payment">
              Promo Payment
            </label>

            <input type="text"
              class="form-control"
              id="promo_payment"
              placeholder="Search by promo payment here"
              v-model="params.promo_payment"
              @keyup="onInput">
          </div>
        </div>
      </div>

      <div class="box">
        <div class="box-body">
          <div class="box-header">
            <div class="box-title">
              <h3>Promo BIN</h3>
            </div>
            <a class="btn btn-success pull-right"
              @click.prevent="add">
              Create New
            </a>
          </div>

          <div class="box-body table-responsive">
            <table class="table table-hover">
              <transition name="fade" mode="out-in">
                <tbody v-if="isLoading" key="loading">
                  <tr>
                    <td colspan="4">
                      <strong>Loading</strong>
                    </td>
                  </tr>
                </tbody>

                <tbody v-else-if="!isLoading && items.length < 1" key="empty">
                  <tr>
                    <td colspan="4">
                      <strong>Result not found</strong>
                    </td>
                  </tr>
                </tbody>

                <tbody v-else key="data">
                  <tr>
                    <th>Promo Payment</th>
                    <th>Promo Codes</th>
                    <th>BIN</th>
                    <th class="text-center" style="width: 10rem">Action</th>
                  </tr>

                  <tr v-for="(item, index) in items" :key="index">
                    <td>{{ item.promo_config }}</td>
                    <td>
                      <span class="label label-info"
                        v-for="code in item.code">
                        {{ code }}
                      </span>
                    </td>
                    <td>
                      <span class="label label-default"
                        v-for="bin in item.bin">
                        {{ bin }}
                      </span>
                    </td>
                    <td>
                      <a class="btn btn-primary btn-xs"
                        @click.prevent="edit(item.promo_config_id)">
                        Edit
                      </a>
                      <a class="btn btn-danger btn-xs"
                        @click.prevent="remove(item)">
                        Delete
                      </a>
                    </td>
                  </tr>
                </tbody>
              </transition>
            </table>
          </div>

          <div class="box-footer">
            <Pagination
              :pagination="pagination"
              @goto-page="changePage" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Common from '@/mixins/Common';
import Pagination from '@/components/modules/common/Pagination';

export default {
  name: 'PromoBinIndex',

  mixins: [Common],

  components: {
    Pagination,
  },

  data() {
    return {
      isLoading: true,
      items: [],
      pagination: {},

      params: {
        promo_payment: null,
      },
    };
  },

  methods: {
    onInput: debounce(function debouncedInput() {
      this.fetch();
    }, 500),

    fetch(page) {
      const pageQuery = this.$route.query.page;
      this.params.page = page || pageQuery;

      this.axios.get('/promobins', { params: this.params })
        .then((response) => {
          const { data, meta } = response.data;

          if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
            this.items = [];
            this.pagination = {};
            return;
          }

          this.items = data;
          this.pagination = meta.pagination;
          this.isLoading = false;
        })
        .catch(() => {
          this.$swal({
            title: 'Fetch Failed',
            text: 'Failed to fetch Promo BIN data',
            type: 'warning',
            timer: 5000,
          });
        });

      if (page) {
        window.history.pushState(`Promo BIN page: ${page}`, null, `/promo/bin?page=${page}`);
      }
    },

    changePage(page) {
      this.fetch(page);
    },

    add() {
      this.$router.push({ name: 'promo-bin-create' });
    },

    edit(id) {
      this.$router.push({
        name: 'promo-bin-edit',
        params: { id },
      });
    },

    delete(item) {
      this.axios.delete(`/promobins/${item.promo_config_id}`)
        .then(() => {
          this.fetch();

          this.$swal({
            title: 'Deleted',
            text: 'Promo BIN has been deleted.',
            type: 'success',
            timer: 3000,
          });
        })
        .catch((error) => {
          console.log('Error', error);
        });
    },

    remove(item) {
      this.$swal({
        title: 'Deleting Promo BIN',
        text: 'Are you sure you want to delete Promo Bin?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      })
      .then((result) => {
        if (result.value) {
          this.delete(item);
        } else {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }

        if (result.dismiss === 'overlay' || result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            type: 'info',
            timer: 3000,
          });
        }
      });
    },
  },

  created() {
    this.fetch();
  },
};
</script>

<style lang="scss">
  .label {
    margin: 0 0.125rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/promo/bin/Index.vue